import React from 'react';
import { Box, Typography } from '@mui/material';
import styles from '../styles.module.scss';
import { TableRowProps } from '../types';
import { Tooltip } from '@mui/material';
import { CmhcIcon, CmhcIconSize } from '@cmhc-schl/hearth-ui';

export const TableRow = ({
  leftTitle,
  leftValue,
  rightTitle,
  rightValue,
  className,
  rightTitleTooltip
}: TableRowProps) => {
  return (
    <Box className={`${styles.tableRow} ${className}`}>
      <Box className={styles.tableColumn}>
        <Box className={styles.leftCell}>
          <Typography variant="h6" className={styles.cellTitle}>
            {leftTitle}
          </Typography>
        </Box>
        <Box className={styles.rightCell}>
          <Typography variant="h6" className={styles.cellValue}>
            {React.createElement(leftValue)}
          </Typography>
        </Box>
      </Box>
      <Box className={styles.tableColumn}>
        <Box className={styles.leftCell}>
          <Typography variant="h6" className={styles.cellTitle}>
            {rightTitle}
            {rightTitleTooltip && (
              <Tooltip
                title={rightTitleTooltip}
                placement="top-start"
                arrow
                slotProps={{
                  tooltip: {
                    className: styles.loansInventoryToolTip
                  },
                  arrow: {
                    className: styles.tooltipArrow
                  }
                }}
              >
                <div
                  style={{
                    display: 'inline-block',
                    marginLeft: '8px'
                  }}
                >
                  <CmhcIcon size={CmhcIconSize.SMALL} type="icon_info_outlined" />
                </div>
              </Tooltip>
            )}
          </Typography>
        </Box>
        <Box className={styles.rightCell}>
          <Typography variant="h6" className={styles.cellValue}>
            {React.createElement(rightValue)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
